var Transition = function () {

	var comp = $('[data-component="transitions"]'),
	menu,
	cases,
	$id;

	this.init = function () {

		this.filter();
		this.select();

		if($(window).width() <= 1024) {
			comp.each(function() {
				menu = $(this).find('[data-component="border-menu"]');
				cases = $(this).find('[data-component="study"]');
				cases.each(function() {
					if($(this).data('year') == menu.find('.active').data('id') || menu.find('.active').data('id') == 'all'){
						$(this).parent().show();
					}
				});
			});
		}

	}

	this.filter = function () {

		comp.each(function() {
			menu = $(this).find('[data-component="border-menu"]');
			cases = $(this).find('[data-component="study"]');

			menu.find('a').on('click', function(e) {
				e.preventDefault();

				$id = $(this).data('id');
				menu.find('a').removeClass('active');
				$(this).addClass('active');

				if ($id == 'Todos' || $id == 'all') {
					cases.parent('.col-xs-12').fadeIn(300);
				}	else {
					cases.each(function() {
						if ($(this).data('year') == $id) {
							$(this).closest('.col-xs-12').fadeIn(300);
						} else {
							$(this).closest('.col-xs-12').fadeOut(300);
						}
					});
				}
			});

		});

	}

	this.select = function () {

		comp.find('.select').each(function(){
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		comp.find('.select select').on('change', function() {
			$(this).prev('span').text($(this).find('option:selected').text());

			comp.each(function() {
				menu = $(this).find('[data-component="border-menu"]');
				cases = $(this).find('[data-component="study"]');
				cases.parent().hide(200);
				cases.each(function() {
					if($(this).data('year') == comp.find('select option:selected').val()){
						$(this).parent().delay(201).show(300);
					}
					else if(comp.find('select option:selected').val() == 'all' || comp.find('select option:selected').val() == 'Todos'){
						$(this).parent().delay(201).show(300);
					}
				});
			});
		});

	}

	return this.init();

}
